import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Phone } from "lucide-react";
import { api } from "../lib/api";
import type { Adviser } from "./admin/AdvisersEditor";

export const useMyAdviser = () => useQuery<Adviser>({ queryKey: ["my-adviser"], queryFn: () => api.get("/adviser/mine").then((r) => r.data), staleTime: 300000 });

/** Personal naming: the adviser's first name, or "the Hourlier family" when nobody is assigned. */
export function useAdviserName() {
  const { data: a } = useMyAdviser();
  const named = !!a && !/^the /i.test(a.name);
  const first = named ? a!.first_name || a!.name.split(" ")[0] : "";
  return { named, first, who: named ? first : "the Hourlier family", Who: named ? first : "The Hourlier family", they: named ? first : "we", their: named ? `${first}'s` : "our", adviser: a };
}

export function AdviserCard({ fallbackImg }: { fallbackImg: string }) {
  const { data: a } = useMyAdviser();
  const team = !a || /^the /i.test(a.name);
  return (
    <div className="mt-8 border border-border" data-testid="adviser-card">
      <div className="aspect-[4/3] overflow-hidden bg-[var(--parchment)]"><img src={a?.photo_url || fallbackImg} alt={a?.name || "The Hourlier family"} className="h-full w-full object-cover" data-testid="adviser-card-photo" /></div>
      <div className="p-5">
        <div className="eyebrow">{team ? "The Hourlier family" : `${(a!.first_name || a!.name.split(" ")[0])} looks after your cellar`}</div>
        <div className="mt-1 font-serif text-2xl" data-testid="adviser-card-name">{a?.name || "The Hourlier team"}</div>
        {a?.role && <div className="text-sm text-neutral-500" data-testid="adviser-card-role">{a.role}</div>}
        {a?.bio && <p className="mt-3 text-sm leading-relaxed text-neutral-700" data-testid="adviser-card-bio">{a.bio}</p>}
        <p className="mt-3 flex items-center gap-2 text-xs text-neutral-500"><Phone className="h-3.5 w-3.5" strokeWidth={1.5} />Available Monday–Saturday, 9am–5:30pm · 01332 341466</p>
      </div>
    </div>
  );
}
